/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import wizardStyle from "../wizardStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import IconHouse from "../../../assets/icons/provision/toggleable/IconHouse";
import IconHighway from "../../../assets/icons/traffic/toggleable/IconHighway";
import IconQuestionMark from "../../../assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import { Box } from "@mui/material";

export default function SpeedingLocality({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="locality"
                question={translate("traffic.locality.label", values)}
                options={[
                  {
                    labelText: translate("traffic.locality.options.in_town.label", values),
                    labelIcon: <IconHouse />,
                    labelIconActive: <IconHouse active />,
                    value: "in_town",
                  },
                  {
                    labelText: translate("traffic.locality.options.out_of_town.label", values),
                    labelIcon: <IconHighway />,
                    labelIconActive: <IconHighway active />,
                    value: "out_of_town",
                  },
                  {
                    labelText: translate("traffic.locality.options.unknown.label", values),
                    labelIcon: <IconQuestionMark />,
                    labelIconActive: <IconQuestionMark active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
